export function resolveUserAgentConfig(input) {
  return input;
}